module.exports = __webpack_public_path__ + "static/death_taxes-96f36a5e7644b9bb2afb614099650f90.png";